export enum AppError {
  ROW_REFERENCED,
  EMAIL_ALREADY_IN_USE,
  PRODUCT_ORDER_MISSING_WASTER_PRODUCER,
  PRODUCT_ORDER_MISSING_PRODUCT,
  PRODUCT_ORDER_MISSING_BILLING_ADDRESS,
}
